import React from "react"
import { H2, H3 } from "../../../designSystem/typography/Heading"
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { AmorgMenu, AmorgMenuContent, LeadingTrailingContentMenuItem, StyleVariant, StyleVariants } from "../../../designSystem/amorgMenu";
import { AmorgMenuButton } from "../../../designSystem/amorgMenu/AmorgMenuButton";


export const AmorgMenuOverview = (): JSX.Element => {

    return (
        <Flex flexDirection="column" gap={24}>
            <H2>New menu items</H2>

            <Flex flexDirection="row" gap={16}>
                <div style={{flexGrow:1}}>
                    <H3>Med pop-up menus defineret for menu items</H3>
                    <AmorgMenu content={[
                            {
                                type:'leadingTrailingContent',
                                leadingContent:{ type: "icon", iconName:'interface_actions_copy'},
                                primaryContent:{
                                    type: "text",
                                    text: "Her er et menuItem der kan klikkes på"
                                },
                                trailingContent:{ type: "icon", iconName:'actions_done'},
                                styleVariant:"default",
                                onClick:() => alert('klik'),
                                popupMenu:{
                                    icon:'navigation_context',
                                    content:[
                                        {
                                            type:'leadingContent',
                                            styleVariant:'emphasized',
                                            leadingContent:{ type:'icon', iconName:'actions_plus'},
                                            primaryContent:{ type:'text', text:'Opret en ting'},
                                            onClick:() => alert('Klikkede på Opret en ting')
                                        },
                                        { type:'separator' },
                                        {
                                            type:'leadingContent',
                                            styleVariant:'destructive',
                                            leadingContent:{ type:'icon', iconName:'interface_actions_delete'},
                                            primaryContent:{ type:'text', text:'Slet en ting'},
                                            onClick:() => alert('Klikkede på Slet en ting')
                                        },
                                        { type:'label', text:'Her er en label' },
                                        {
                                            type:'leadingContent',
                                            styleVariant:'default',
                                            leadingContent:{ type:'icon', iconName:'arrows_arrow_arrowUp'},
                                            primaryContent:{ type:'text', text:'Flyt en ting'},
                                            onClick:() => alert('Klikkede på Flyt en ting')
                                        }
                                    ]
                                }
                            },
                            {
                                type:'leadingTrailingContent',
                                leadingContent:{ type: "icon", iconName:'interface_actions_attach'},
                                primaryContent:{
                                    type: "textWithSubtext",
                                    text: "Her er et til",
                                    subtext: '... men det kan ikke klikkes på'
                                },
                                trailingContent:{ 
                                    type: "text", text:'Endnu en tekst'
                                },
                                styleVariant:"strike-through",
                                popupMenu:{
                                    icon:'caret_caretForward',
                                    content:[
                                        {
                                            type:'leadingContent',
                                            styleVariant:'emphasized',
                                            leadingContent:{ type:'icon', iconName:'actions_plus'},
                                            primaryContent:{ type:'text', text:'Opret en ting'},
                                            onClick:() => alert('Klikkede på Opret en ting')
                                        },
                                        {
                                            type:'leadingContent',
                                            styleVariant:'default',
                                            leadingContent:{ type:'icon', iconName:'arrows_arrow_arrowUp'},
                                            primaryContent:{ type:'text', text:'Flyt en ting'},
                                            onClick:() => alert('Klikkede på Flyt en ting')
                                        }
                                    ]
                                }
                            }
                        ]} />
                </div>
            </Flex>

            <Flex flexDirection="row" gap={16}>
                <div style={{flexGrow:1}}>
                    <H3>Custom</H3>
                    <AmorgMenu>
                        <LeadingTrailingContentMenuItem 
                            leadingContent={{ type: "icon", iconName:'interface_actions_attach', styleVariantOverride:'destructive'}} 
                            primaryContent={{
                                type: "textWithSubtext",
                                text: "Forskellige styles på alt!",
                                subtext: 'Default style er default',
                                styleVariantOverride:'strike-through',
                                subtextStyleVariantOverride:'emphasized'
                            }}
                            trailingContent={{ type: "icon", iconName:'interface_actions_like', styleVariantOverride:'destructive'}}
                            styleVariant={"default"} />

                        <LeadingTrailingContentMenuItem 
                            leadingContent={{ type: "icon", iconName:'interface_actions_attach'}} 
                            primaryContent={{
                                type: "textWithSubtext",
                                text: "Variation af flex-grow",
                                subtext: 'Default style er default',
                                flex:'0.3 1.0 0%'
                            }}
                            trailingContent={{ 
                                type: "text", text:'Her er der så en væsentligt længere text, der retfærdigvis bør få tildelt mere plads',
                                flex:'0.7 1.0 0%'
                            }}
                            styleVariant={"default"} />
                    </AmorgMenu>
                </div>
                <div>
                    <AmorgMenuButton content={[
                        {
                            type:'leadingContent',
                            styleVariant:'emphasized',
                            leadingContent:{ type:'icon', iconName:'actions_plus'},
                            primaryContent:{ type:'text', text:'Opret en ting'},
                            onClick:() => alert('Klikkede på Opret en ting')
                        },
                        { type:'separator' },
                        {
                            type:'leadingContent',
                            styleVariant:'destructive',
                            leadingContent:{ type:'icon', iconName:'interface_actions_delete'},
                            primaryContent:{ type:'text', text:'Slet en ting'},
                            onClick:() => alert('Klikkede på Slet en ting')
                        },
                        { type:'label', text:'Her er en label' },
                        {
                            type:'leadingContent',
                            styleVariant:'default',
                            leadingContent:{ type:'icon', iconName:'arrows_arrow_arrowUp'},
                            primaryContent:{ type:'text', text:'Flyt en ting'},
                            onClick:() => alert('Klikkede på Flyt en ting')
                        },
                    ]} />
                </div>
            </Flex>

            {StyleVariants.map(styleVariant => 
                <Flex flexDirection="column" gap={16} key={styleVariant}>
                    <H3>styleVariant:{styleVariant}</H3>
                    <Flex flexDirection="row" gap={10} justifyContent="stretch">
                        <div style={{flexGrow:1}}>
                            <H3>Non-selectable</H3>
                            <AmorgMenu
                                content={[
                                    ...getLeadingMenuItemVariations(styleVariant),
                                    { type:'separator'},
                                    ...getTrailingMenuItemVariations(styleVariant),
                                    { type:'separator'},
                                    ...getLeadingTrailingMenuItemVariations(styleVariant)
                                ]}/>
                        </div>
                        <div style={{flexGrow:1}}>
                            <H3>Selectable</H3>
                            <AmorgMenu
                                content={[
                                    ...getLeadingMenuItemVariations(styleVariant, () => alert('Click leadingMenuItem')),
                                    { type:'separator'},
                                    ...getTrailingMenuItemVariations(styleVariant, () => alert('Click trailingMenuItem')),
                                    { type:'separator'},
                                    ...getLeadingTrailingMenuItemVariations(styleVariant, () => alert('Click leadingTrailingMenuItem')),
                                ]}/>
                        </div>      
                    </Flex>
                </Flex>
            )}
        </Flex>
    )
}

function getLeadingMenuItemVariations(styleVariant:StyleVariant, onClick?:()=>void):AmorgMenuContent[]
{
    return [
        {   type:'label',
            text:'LeadingContent'
        },
        {
            type: 'leadingContent',
            leadingContent: { type: 'icon', iconName: 'navigation_map' },
            primaryContent: { type:'text', text: 'icon, text' },
            styleVariant,
            onClick
        },
        {
            type: 'leadingContent',
            leadingContent: { type: 'none' },
            primaryContent: { type:"text", text: 'none, text' },
            styleVariant,
            onClick
        },
        {
            type: 'leadingContent',
            leadingContent: { type: 'icon', iconName: 'interface_glyph_location' },
            primaryContent: { type:'textWithSubtext', text: 'icon, textWithSubtext', subtext:'subtext here' },
            styleVariant,
            onClick
        },
        {
            type: 'leadingContent',
            leadingContent: { type: 'none' },
            primaryContent: { type:'textWithSubtext', text: 'none, textWithSubtext', subtext:'subtext here' },
            styleVariant,
            onClick
        },
        {
            type: 'leadingContent',
            leadingContent: { type: 'icon', iconName: 'navigation_map' },
            primaryContent: { type:'text', text: 'icon, text - selected' },
            selectedState:true,
            styleVariant,
            onClick
        },
        {
            type: 'leadingContent',
            leadingContent: { type: 'icon', iconName: 'navigation_map' },
            primaryContent: { type:'text', text: 'icon, text - tooltip' },
            toolTip:"WOW! Det ser godt ud!",
            styleVariant,
            onClick
        },
        {
            type: 'leadingContent',
            leadingContent: { type: 'icon', iconName: 'navigation_map' },
            primaryContent: { type:'text', text: 'icon, text - selected, tooltip' },
            toolTip:"WOW! Det ser godt ud!",
            selectedState:true,
            styleVariant,
            onClick
        }
    ]
}
function getTrailingMenuItemVariations(styleVariant:StyleVariant, onClick?:()=>void):AmorgMenuContent[]
{
    return [
        {   type:'label',
            text:'trailingContent'
        },
        {
            type: 'trailingContent',
            primaryContent: { type:'text', text: 'text, icon' },
            trailingContent: { type: 'icon', iconName: 'navigation_map' },
            styleVariant,
            onClick
        },
        {
            type: 'trailingContent',
            primaryContent: { type:"text", text: 'text, none' },
            trailingContent: { type: 'none' },
            styleVariant,
            onClick
        },
        {
            type: 'trailingContent',
            primaryContent: { type:"text", text: 'text, text' },
            trailingContent: { type: 'text', text:'text' },
            styleVariant,
            onClick
        },
        {
            type: 'trailingContent',
            primaryContent: { type:'textWithSubtext', text: 'textWithSubtext, icon', subtext:'subtext here' },
            trailingContent: { type: 'icon', iconName: 'interface_glyph_location' },
            styleVariant,
            onClick
        },
        {
            type: 'trailingContent',
            primaryContent: { type:'textWithSubtext', text: 'textWithSubtext, none', subtext:'subtext here' },
            trailingContent: { type: 'none' },
            styleVariant,
            onClick
        },    
        {
            type: 'trailingContent',
            primaryContent: { type:'textWithSubtext', text: 'textWithSubtext, text', subtext:'subtext here' },
            trailingContent: { type: 'text', text:'text' },
            styleVariant,
            onClick
        },                        
        {
            type: 'trailingContent',
            primaryContent: { type:'text', text: 'text, icon - selected' },
            trailingContent: { type: 'icon', iconName: 'navigation_map' },
            selectedState:true,
            styleVariant,
            onClick
        },
        {
            type: 'trailingContent',
            primaryContent: { type:'text', text: 'text, icon - tooltip' },
            trailingContent: { type: 'icon', iconName: 'navigation_map' },
            toolTip:"WOW! Det ser godt ud!",
            styleVariant,
            onClick
        },
        {
            type: 'trailingContent',
            primaryContent: { type:'text', text: 'text, icon - selected, tooltip' },
            trailingContent: { type: 'icon', iconName: 'navigation_map' },
            toolTip:"WOW! Det ser godt ud!",
            selectedState:true,
            styleVariant,
            onClick
        }
    ]
}
function getLeadingTrailingMenuItemVariations(styleVariant:StyleVariant, onClick?:()=>void):AmorgMenuContent[]
{
    return [
        {   type:'label',
            text:'leadingTrailingContent'
        },

        {
            type: 'leadingTrailingContent',
            leadingContent: { type: 'none' },
            primaryContent: { type:'text', text: 'none, text, none' },
            trailingContent: { type: 'none' },
            styleVariant,
            onClick
        },
        {
            type: 'leadingTrailingContent',
            leadingContent: { type: 'none' },
            primaryContent: { type:'text', text: 'none, text, icon' },
            trailingContent: { type: 'icon', iconName: 'navigation_map' },
            styleVariant,
            onClick
        },
        {
            type: 'leadingTrailingContent',
            leadingContent: { type: 'none' },
            primaryContent: { type:'text', text: 'none, text, text' },
            trailingContent: { type: 'text', text: 'text' },
            styleVariant,
            onClick
        },

        
        {
            type: 'leadingTrailingContent',
            leadingContent: { type: 'none' },
            primaryContent: { type:'textWithSubtext', text: 'none, textWithSubtext, none', subtext:'subtext' },
            trailingContent: { type: 'none' },
            styleVariant,
            onClick
        },
        {
            type: 'leadingTrailingContent',
            leadingContent: { type: 'none' },
            primaryContent: { type:'textWithSubtext', text: 'none, textWithSubtext, icon', subtext:'subtext' },
            trailingContent: { type: 'icon', iconName: 'navigation_map' },
            styleVariant,
            onClick
        },
        {
            type: 'leadingTrailingContent',
            leadingContent: { type: 'none' },
            primaryContent: { type:'textWithSubtext', text: 'none, textWithSubtext, text', subtext:'subtext' },
            trailingContent: { type: 'text', text: 'text' },
            styleVariant,
            onClick
        },


        {
            type: 'leadingTrailingContent',
            leadingContent: { type: 'icon', iconName:'interface_actions_mail' },
            primaryContent: { type:'text', text: 'icon, text, none' },
            trailingContent: { type: 'none' },
            styleVariant,
            onClick
        },
        {
            type: 'leadingTrailingContent',
            leadingContent: { type: 'icon', iconName:'interface_actions_mail' },
            primaryContent: { type:'text', text: 'icon, text, icon' },
            trailingContent: { type: 'icon', iconName: 'navigation_map' },
            styleVariant,
            onClick
        },
        {
            type: 'leadingTrailingContent',
            leadingContent: { type: 'icon', iconName:'interface_actions_mail' },
            primaryContent: { type:'text', text: 'icon, text, text' },
            trailingContent: { type: 'text', text: 'text' },
            styleVariant,
            onClick
        },

        
        {
            type: 'leadingTrailingContent',
            leadingContent: { type: 'icon', iconName:'interface_actions_mail' },
            primaryContent: { type:'textWithSubtext', text: 'icon, textWithSubtext, none', subtext:'subtext' },
            trailingContent: { type: 'none' },
            styleVariant,
            onClick
        },
        {
            type: 'leadingTrailingContent',
            leadingContent: { type: 'icon', iconName:'interface_actions_mail' },
            primaryContent: { type:'textWithSubtext', text: 'icon, textWithSubtext, icon', subtext:'subtext' },
            trailingContent: { type: 'icon', iconName: 'navigation_map' },
            styleVariant,
            onClick
        },
        {
            type: 'leadingTrailingContent',
            leadingContent: { type: 'icon', iconName:'interface_actions_mail' },
            primaryContent: { type:'textWithSubtext', text: 'icon, textWithSubtext, text', subtext:'subtext' },
            trailingContent: { type: 'text', text: 'text' },
            styleVariant,
            onClick
        },
  
        {
            type: 'leadingTrailingContent',
            leadingContent: { type: 'icon', iconName:'actions_done' },
            primaryContent: { type:'textWithSubtext', text: 'icon, textWithSubtext, icon - selected', subtext: 'subtext' },
            trailingContent: { type: 'icon', iconName: 'navigation_map' },
            selectedState:true,
            styleVariant,
            onClick
        },
        {
            type: 'leadingTrailingContent',
            leadingContent: { type: 'icon', iconName:'actions_done' },
            primaryContent: { type:'textWithSubtext', text: 'icon, textWithSubtext, icon - tooltip', subtext: 'subtext' },
            trailingContent: { type: 'icon', iconName: 'navigation_map' },
            toolTip:"WOW! Det ser godt ud!",
            styleVariant,
            onClick
        },
        {
            type: 'leadingTrailingContent',
            leadingContent: { type: 'icon', iconName:'actions_done' },
            primaryContent: { type:'textWithSubtext', text: 'icon, textWithSubtext, icon - selected, tooltip', subtext: 'subtext' },
            trailingContent: { type: 'icon', iconName: 'navigation_map' },
            selectedState:true,
            toolTip:"WOW! Det ser godt ud!",
            styleVariant,
            onClick
        }
    ]
}